import { useState, useEffect } from "react";
import "./data-collection.css";
import axios from 'axios';
import Swal from "sweetalert2";

const DataCollection = (props) => {

    //variables
    const [flightNumber, setFlightNumber] = useState('');
    const [flightDate, setFlightDate] = useState('');
    const [flightOrigin, setFlightOrigin] = useState('');
    const [flightDestination, setFlightDestination] = useState('');
    const [flightAirline, setFlightAirline] = useState('');
    const [flightTailNumber, setFlightTailNumber] = useState('');
    const { flightData, handleToggleFormFlights } = props;
    const [masters, setMasters] = useState([  ]);
    const [masterId, setMasterId] = useState();
    const [selectedFlights, setSelectedFlights] = useState([]);
    
    //funciones

    useEffect(() => {
      if (flightData && flightData.data && flightData.data.flight) {
        const { flight, date, origin, destination, airline, tail_number,  id } = flightData.data.flight;
        setFlightNumber(flight);
        setFlightDate(date);
        setFlightOrigin(origin);
        setFlightDestination(destination);
        setFlightAirline(airline);
        setFlightTailNumber(tail_number)
        setMasters(flightData.data.masters);
        setMasterId(id)



        // Inicializa selectedFlights con los ids de los vuelos que tienen is_comat como true
      const initiallySelectedFlights = flightData.data.masters
      .filter((flight) => flight.is_comat)
      .map((flight) => flight.id.toString());
    setSelectedFlights(initiallySelectedFlights);

      }
  }, [flightData]);

  useEffect(() => {
    // Loguea los ids de los vuelos seleccionados cada vez que cambie selectedFlights
    // console.log('Selected Flight IDs:', selectedFlights);
  }, [selectedFlights]);

  const handleCheckboxChange = (event) => {
    const flightId = event.target.value;
    const isChecked = event.target.checked;

    setSelectedFlights((prevSelectedFlights) => {
      if (isChecked) {
        // Añadir al array si está marcado y no está ya en el array
        return [...prevSelectedFlights, flightId];
      } else {
        // Eliminar del array si está desmarcado
        return prevSelectedFlights.filter((id) => id !== flightId);
      }
    });
  };

  // Función para enviar actualización de is_coat
  const updateComatStatus = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/flights/update/${masterId}`,
        {
          is_comat: selectedFlights,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`, 'Content-Type': 'application/json',
          },
        }
      );
      
      const data = response.data

      if(data){
        Swal.fire({
          icon: 'success',
          title: 'Guias actualizadas',
          text: 'La información ha sido guardada con éxito',
        });
        handleToggleFormFlights();
      }
      else{
        Swal.fire({
          icon: 'error',
          title: 'No se actualizo la información',
          text: 'Intente más tarde',
        });
      }
    } catch (error) {
      console.error('Error al enviar la petición:', error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extraer los componentes de la fecha y la hora
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Formatear la fecha y la hora en el formato deseado
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  };

  //vista final
  return (
    <>
      <div className="card mb-4 px-3 pb-2">
        <div className="card-body">
          <div className="row">
            <div className="col-6 col-md-4">
              <p className="font-semibold mb-1">Vuelo:</p>
              <p className="">{flightNumber}</p>
            </div>

            <div className="col-6 col-md-4">
              <p className="font-semibold mb-1">Fecha:</p>
              <p className="">{formatDate(flightDate)}</p>
            </div>

            <div className="col-6 col-md-4">
              <p className="font-semibold mb-1">Origen:</p>
              <p className="">{flightOrigin}</p>
            </div>

            <div className="col-6 col-md-4">
              <p className="font-semibold mb-1">Destino:</p>
              <p className="">{flightDestination}</p>
            </div>

            <div className="col-6 col-md-4 ">
              <p className="font-semibold mb-1">Aerolinea:</p>
              <p className="">{flightAirline}</p>
            </div>

            <div className="col-6 col-md-4 ">
              <p className="font-semibold mb-1">Matrícula:</p>
              <p className="">{flightTailNumber}</p>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <div
            className="dataTables_wrapper dt-bootstrap4 no-footer"
            id="datatables_wrapper"
          >
            <div className="row">
              <div className="col">
                <table
                  className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                  role="grid"
                  aria-describedby="datatables_info"
                >
                  <thead>
                    <tr role="row">
                      <th
                        className="sorting text-center text-center"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "250px" }}
                      >
                        Master
                      </th>
                      <th
                        className="sorting text-center"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "110px" }}
                      >
                        Origen
                      </th>
                      <th
                        className="sorting text-center"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "110px" }}
                      >
                        Destino
                      </th>
                      <th
                        className="sorting text-center"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "110px" }}
                      >
                        Piezas
                      </th>
                      <th
                        className="sorting text-center"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "110px" }}
                      >
                        Peso
                      </th>
                      <th
                        className="sorting text-center"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "110px" }}
                      >
                        Tipo
                      </th>
                      <th
                        className="sorting text-center"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "250px" }}
                      >
                        Descripción
                      </th>
                      <th
                        className="sorting text-center"
                        tabIndex={0}
                        aria-controls="datatables"
                        rowSpan={1}
                        colSpan={1}
                        style={{ width: "250px" }}
                      >
                        Comat (AM/5D)
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {masters.map((flight, index) => (
                      <tr key={index}>
                          <td>{flight.awb}</td>
                          <td>{flight.origin}</td>
                          <td>{flight.destination}</td>
                          <td>{flight.pieces}</td>
                          <td>{flight.weight}</td>
                          <td>{flight.type}</td>
                          <td>{flight.description}</td>
                          <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={flight.id.toString()}
                            aria-label="Select"
                            value={flight.id}
                            checked={selectedFlights.includes(flight.id.toString())}
                            onChange={handleCheckboxChange}
                            />
                          </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col offset-md-4 d-flex justify-content-end pt-3">
          <button
            className="col col-md-2 btn-amc-blue mt-3 mt-md-0 ml-2"
            onClick={handleToggleFormFlights}
          >
            Regresar
          </button>
          <button
            className="col col-md-2 btn-amc-pink mt-3 mt-md-0 ml-2"
            onClick={updateComatStatus}
          >
            Guardar
          </button>
        </div>
      </div>
    </>
  );
};

export default DataCollection;
